import React, { useState } from 'react';
import { CATEGORY_OPTIONS } from '../utils/categoryConfig';
import './SearchAndFilter.css';

const SearchAndFilter = ({ onFilterChange, initialFilters = {} }) => {
  const [search, setSearch] = useState(initialFilters.search || '');
  const [category, setCategory] = useState(initialFilters.category || '');
  const [sortBy, setSortBy] = useState(initialFilters.sortBy || 'created_at');
  const [order, setOrder] = useState(initialFilters.order || 'desc');

  const handleApply = () => {
    onFilterChange({
      search: search.trim() || undefined,
      category: category || undefined,
      sortBy,
      order
    });
  };

  const handleClear = () => {
    setSearch('');
    setCategory('');
    setSortBy('created_at');
    setOrder('desc');
    onFilterChange({
      sortBy: 'created_at',
      order: 'desc'
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleApply();
    }
  };

  return (
    <div className="search-filter">
      <div className="search-filter-row">
        <input
          type="text"
          className="search-input"
          placeholder="Search posts by title or content..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>

      <div className="search-filter-row">
        <select 
          className="filter-select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          {CATEGORY_OPTIONS.map(cat => (
            <option key={cat.value} value={cat.value}>
              {cat.icon} {cat.label}
            </option>
          ))}
        </select>

        <select 
          className="filter-select"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="created_at">Posted Time</option>
          <option value="likes">Most Liked</option>
          <option value="dislikes">Most Disliked</option>
          <option value="comments">Most Commented</option>
        </select>

        <select 
          className="filter-select"
          value={order}
          onChange={(e) => setOrder(e.target.value)}
        >
          <option value="desc">Descending</option>
          <option value="asc">Ascending</option>
        </select>

        <button className="feed-filter-btn apply-btn" onClick={handleApply}>
          Apply
        </button>

        <button className="feed-filter-btn clear-btn" onClick={handleClear}>
          Clear
        </button>
      </div>
    </div>
  );
};

export default SearchAndFilter;
